import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	topNav: {
		defaultMessage: 'Primary',
		id: 'atlassian-navigation.top-nav',
		description:
			'Describes the specific role of this navigation component for users viewing the page with a screen reader. Differentiates from other navigation components on a page.',
	},
	more: {
		defaultMessage: 'More',
		id: 'atlassian-navigation.more',
		description: '"More" primary menu item. Shown when viewport does not fit all the primary items',
	},
});
